import useSWR from 'swr';

import { fetchEndpointData } from '@utils/fetchEndpointData';

import type { NotificationResponse, NotificationsResponse } from './endpoints/NotificationsEndpoint.types';

export type Notification = NotificationResponse;

export const NOTIFICATIONS_SWR_KEY = 'notifications';

export async function getNotifications(cursor?: string, take?: number): Promise<NotificationsResponse> {
  const params = new URLSearchParams();
  if (cursor) params.set('id', cursor);
  if (take != null) params.set('take', take.toString());

  const queryString = params.toString();
  const url = queryString ? `/api/v1/notifications?${queryString}` : '/api/v1/notifications';
  return fetchEndpointData<NotificationsResponse>(url);
}

export async function deleteNotification(notificationId: string): Promise<{ success: boolean }> {
  return fetchEndpointData(`/api/v1/notifications/${notificationId}`, {
    method: 'DELETE',
  });
}

export async function markNotificationsAsRead(lastNotificationTimestamp: string): Promise<{ success: boolean }> {
  return fetchEndpointData('/api/v1/notifications/mark-read', {
    method: 'POST',
    body: { lastNotificationTimestamp },
  });
}

export function useNotifications(take = 100) {
  return useSWR([NOTIFICATIONS_SWR_KEY, take], () => getNotifications(undefined, take));
}
